export default __webpack_public_path__ + "static/media/hht2_ep11_timeline_q04_b.3edad7fc.png";